"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DialogContent = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Content = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  padding: theme.spacing(6, 3),
  background: theme.palette.background.paper
}));
const Text = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  padding: theme.spacing(6, 0)
}));
const Actions = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center'
});
const DialogContent = ({
  actions
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Content, {
    "data-testid": getTestId('content'),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h4",
      component: "div",
      align: "center",
      color: "textSecondary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "congratulations"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Text, {
      variant: "body1",
      align: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "youHaveLoyaltyPointsThatYouCanUseOnThisProduct"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "chooseHowYouWantToPayForIt"
      })]
    }), Boolean(actions) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Actions, {
      "data-testid": getTestId('actions'),
      children: actions
    })]
  });
};
exports.DialogContent = DialogContent;
var _default = exports.default = DialogContent;
